export const formatAction = (action) => {
  if (!action || action === "N/A") return "N/A";

  return action
    .toString()
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};